import { createAction, props } from '@ngrx/store';

export const changeRolleStart = createAction('MITARBEITERVERWALTUNG::ROLLE_CHANGE_START', props<{rolleId: number}>());
export const changeRolleSucceeded = createAction(
    'MITARBEITERVERWALTUNG::ROLLE_CHANGE_SUCCEEDED',
    props<{ rollenId: number }>(),
);
export const changeRolleFailed = createAction('MITARBEITERVERWALTUNG::ROLLE_CHANGE_FAILED');
